export enum NOTIFICATION_BROADCAST_TYPE {
  ASYNC_DELETE_FAILED = "async-delete-failed",
  ASYNC_DELETE_SUCCESS = "async-delete-success",
  INTERVENTION_TRANSITION = "transition-intervention",
  OBSERVATION_TRANSITION = "transition-observation",
  JOB_MODULE_COMPLETED = "job-module-completed",
  JOB_MODULE_FAILED = "job-module-failed",
  JOB_MODULE_RUNNING = "job-module-running",
  OBSERVATION_COMMENTED = "observation-commented",
}
